import { Notification, NotificationTheme } from '@wix/design-system';
import React, { FC } from 'react';

type BannerProps = {
  children: React.ReactNode;
  theme: NotificationTheme;
  onBannerClose?: () => void;
  hideBanner?: boolean;
  autoHide?: boolean;
  dataHook?: string;
};

const AUTO_HIDE_TIMEOUT = 10 * 1000; // 10 seconds

export const Banner: FC<BannerProps> = ({
  theme,
  autoHide,
  children,
  onBannerClose,
  hideBanner = false,
  dataHook = 'banner',
}) => {
  return (
    <Notification
      dataHook={dataHook}
      show={!hideBanner}
      autoHideTimeout={autoHide ? AUTO_HIDE_TIMEOUT : undefined}
      theme={theme}
      onClose={onBannerClose}
    >
      <Notification.TextLabel ellipsis={false} textAlign="start">
        {children}
      </Notification.TextLabel>
      <Notification.CloseButton />
    </Notification>
  );
};

